// import React, { useContext, useEffect, useRef, useState } from "react";
// import { useNavigate, useParams } from "react-router";
// import Breadcrumb from "../components/breadCrumb";
// import LargeTitle from "../components/case-tracking/LargeTitle";
// import PopupForm from "../components/case-tracking/PopupForm";
// import ReceiptForm from "../components/case-tracking/ReceiptForm";
// import ServiceDetails from "../components/case-tracking/ServiceDetails";
// import ServiceDetailsPart1 from "../components/case-tracking/ServiceDetailsPart1";
// import ServiceDetailsPart1DeskTop from "../components/case-tracking/ServiceDetailsPart1DeskTop";
// import ServiceDetailsPart2 from "../components/case-tracking/ServiceDetailsPart2";
// import ServiceValue from "../components/case-tracking/ServiceValue";
// import SmallTitle from "../components/case-tracking/SmallTitle";
// import SharedModal from "../components/happiness/SharedModal";
// import ConfirmPayment from "../components/paymentPopup/ConfirmPayment";
// import FailedPayment from "../components/paymentPopup/FailedPayment";
// import SuccessPayment from "../components/paymentPopup/SuccessPayment";
// import { PhrasesContext } from "../context/phrasesContext";
// import ThemeLayout from "../layouts/ThemeLayout";
// import {
//   getComments,
//   getServiceDetails,
//   getCancel_Request,
// } from "../services/Common";
// import { USDollar } from "../utils/helpers";
// import FeedBackQuestions from "../components/FeedBack/FeedBackQuestions";
// import SuccessSurvayAdded from "../components/FeedBack/SuccessSurvayAdded";
// import SuccessSurvayAddedMobile from "../components/FeedBack/SuccessSurvayAddedMobile";
// import { Loader } from "../components/utils";
// import { Disclosure, Transition } from "@headlessui/react";
// import OrderDetailsSectionLatest from "../components/case-tracking/OrderDetailsSectionLatest";
// import CaseDetailsSectionLatest from "../components/case-tracking/CaseDetailsSectionLatest";
// import OrderDetailsSectionLatestMobile from "../components/case-tracking/OrderDetailsSectionLatestMobile";
// import CaseDetailsSectionLatestMobile from "../components/case-tracking/CaseDetailsSectionLatestMobile";

// const OrderDetails = () => {
//   const { caseid, serviceid } = useParams();
//   const [lang, setLang] = useState("");
//   const [service, setService] = useState({});
//   const [comments, setComments] = useState([]);
//   const [openPopub, setOpenPopub] = useState(false);
//   const [openModal, setOpenModal] = useState(false);
//   const [receiptStatus, setReceiptStatus] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [loadingSpinner, setLoadingSpinner] = useState(false);
//   const [successUploadReciept, setSuccessUploadReciept] = useState(false);
//   const [falidUploadReciept, setFalidUploadReciept] = useState(false);
//   const [openModalFail, setOpenModalFail] = useState(false);
//   const [openModalSucc, setOpenModalSucc] = useState(false);

//   const [isSueveyMenu, setIsSueveyMenu] = useState(false);
//   const [isOpenFeedBack, setIsOpenFeedBack] = useState(true);
//   const [isExpand, setIsExpand] = useState(false);
//   const [success, setSuccess] = useState("");

//   const [sidebarHeight, setSidebarHeight] = useState(0);
//   const navbarRef = useRef(null);
//   const [isOpenPopup, setIsOpenPopup] = useState(false);

//   const [enPhrase, arPhrase] = useContext(PhrasesContext);
//   const [selectedDoc, setSelectedDoc] = useState(null);
//   const [uploadedFile, setUploadedFile] = useState("");
//   const [file, setFile] = useState();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const lang = window.localStorage.getItem("lang");
//     let currentLang = lang;
//     if (lang === "en") {
//       document.body.dir = "ltr";
//       setLang("en");
//       currentLang = "en";
//     } else {
//       document.body.dir = "rtl";
//       setLang("ar");
//       currentLang = "ar";
//     }
//     getServiceDetailsService(currentLang);
//     getCommentsService(currentLang);
//   }, []);

//   const getServiceDetailsService = (currentLang) => {
//     return getServiceDetails(caseid, serviceid, currentLang).then((res) => {
//       setService(res);
//       setLoading(false);
//     });
//   };

//   const getCommentsService = (currentLang) => {
//     return getComments(serviceid, currentLang).then((res) => {
//       setComments(res);
//     });
//   };

//   const handelOpenPopup = () => {
//     setOpenPopub(!openPopub);
//   };

//   const uploadReceiptHandler = () => {
//     setReceiptStatus(!receiptStatus);
//   };

//   const surveyFeedBackHandler = () => {
//     setIsSueveyMenu(!isSueveyMenu);
//   };

//   const handleSuccessChange = (newState) => {
//     setSuccess(newState);
//   };

//   useEffect(() => {
//     if (navbarRef.current) {
//       setSidebarHeight(navbarRef.current.offsetHeight);
//     }
//   }, [navbarRef]);

//   const confirmCancel = () => {
//     setLoadingSpinner(true);
//     getCancel_Request(lang, serviceid).then(
//       (res) => {
//         if (res?.isSuccess) {
//           setLoading(false);
//           navigate("/case-overview");
//         } else {
//           window.scrollTo({ top: 0, behavior: "smooth" });
//           setLoadingSpinner(false);
//           return;
//         }
//       },
//       (error) => {
//         console.error("Error submitting form", error);
//         window.scrollTo({ top: 0, behavior: "smooth" });
//         setLoading(false);
//       },
//     );
//   };

//   return (
//     <ThemeLayout navbarRef={navbarRef}>
//       {loading ? (
//         <p className="text-[#b68a35] font-bold font-Almarai mt-[8px]">
//           {lang === "en" ? "Loading..." : "جاري عرض البيانات..."}
//         </p>
//       ) : (
//         <div className="flex flex-col w-full py-4 max-w-[1440px] px-[16px] lg:px-[0px]">
//           <Breadcrumb
//             title={
//               lang === "en" ? enPhrase["lblMycases"] : arPhrase["lblMycases"]
//             }
//             subtitle1={`${service?.caseNumber || ""}`}
//             subtitle1Href={`${
//               service?.caseId === 0
//                 ? "/case-overview"
//                 : `/case-details/${service?.caseId}`
//             }`}
//             last={`${
//               lang === "en"
//                 ? `${enPhrase["lblRequest"]} ${service?.id}`
//                 : `${service?.id} ${arPhrase["lblRequest"]}`
//             }`}
//             lastHref={`/order-details/${service?.caseId}/${service?.id}`}
//           />
//           <div className="flex justify-between items-center mb-[24px] md:mb-8">
//             <div className="flex flex-col xxsm:flex-row justify-between items-center gap-2 capitalize ">
//               <LargeTitle
//                 title={
//                   lang === "en"
//                     ? enPhrase["lblDetails"]
//                     : arPhrase["lblDetails"]
//                 }
//                 nullmargin
//               />
//             </div>
//             {service?.serviceStatusId === 5 && !service?.completeSurvey ? (
//               <button
//                 className="w-[166px] h-[44px] bg-[#A98031] rounded text-[#fff] font-Almarai font-bold text-[16px] px-3"
//                 onClick={surveyFeedBackHandler}
//               >
//                 <p>
//                   {lang === "en"
//                     ? enPhrase["btnSurvey"]
//                     : arPhrase["btnSurvey"]}
//                 </p>
//               </button>
//             ) : (
//               (service?.serviceStatusId === 1 ||
//                 (service?.serviceStatusId === 3 &&
//                   service?.isUploadReceipts === false &&
//                   service?.isPaid === false)) && (
//                 <button
//                   onClick={() => setIsOpenPopup(true)}
//                   className="md:w-[156px] h-[44px] md:bg-[#FFFFFF] rounded md:border md:border-solid md:!border-[#E23636] text-[#E23636] font-Almarai font-bold text-[14px] md:text-[16px] md:px-3"
//                 >
//                   <p>
//                     {lang === "en"
//                       ? enPhrase["lblConfirmCancelRequest"]
//                       : arPhrase["lblConfirmCancelRequest"]}
//                   </p>
//                 </button>
//               )
//             )}
//           </div>

//           {isOpenPopup && (
//             <SharedModal
//               isDeleteConfirmation
//               setOpenModal={setIsOpenPopup}
//               openModal={isOpenPopup}
//             >
//               <div
//                 className="flex flex-col items-center gap-[32px] md:gap-[40px] py-[24px] md:py-[32px] px-[24px] md:px-[40px]"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <img
//                   src="/assets/img/Caution.svg"
//                   alt="aleart"
//                   className="w-[64px] md:w-[80px] h-[52px] md:h-[65.5px]"
//                 />

//                 <p className="font-Almarai font-[400] text-[16px] md:text-[24px] leading-[24px] md:leading-[36px] text-[#010202]">
//                   {lang === "en"
//                     ? enPhrase["lblConfirmCancelRequestTxt"]
//                     : arPhrase["lblConfirmCancelRequestTxt"]}
//                 </p>
//                 <div className="w-full flex flex-col-reverse md:flex-row justify-center gap-[16px]">
//                   <button
//                     className="w-full md:w-[50%] h-[44px] rounded-[4px] px-[16px] bg-[#F2ECCF]"
//                     onClick={() => setIsOpenPopup(false)}
//                   >
//                     <p className="font-Almarai font-bold text-[16px] leading-[20px] text-[#815327]">
//                       {lang === "en"
//                         ? enPhrase["lblGoBackText"]
//                         : arPhrase["lblGoBackText"]}
//                     </p>
//                   </button>
//                   <button
//                     className="w-full md:w-[50%] h-[44px] rounded-[4px] px-[16px] bg-[#B68A35] flex items-center justify-center gap-2"
//                     onClick={confirmCancel}
//                   >
//                     <p className="font-Almarai font-bold text-[16px] leading-[20px] text-[#fff]">
//                       {lang === "en"
//                         ? enPhrase["lblConfirm"]
//                         : arPhrase["lblConfirm"]}
//                     </p>
//                     {loadingSpinner && <Loader color={"white"} />}
//                   </button>
//                 </div>
//               </div>
//             </SharedModal>
//           )}

//           {success ? (
//             window && window.innerWidth <= 1024 ? (
//               <SharedModal isSuccessSurvayMobile setOpenModal={setSuccess}>
//                 <SuccessSurvayAddedMobile
//                   isOrderDetails
//                   sidebarHeight={sidebarHeight}
//                   setIsOpenFeedBack={setIsOpenFeedBack}
//                   feedBackHandler={surveyFeedBackHandler}
//                   lang={lang}
//                   arPhrase={arPhrase}
//                   enPhrase={enPhrase}
//                 />
//               </SharedModal>
//             ) : (
//               <SuccessSurvayAdded
//                 isOrderDetails
//                 sidebarHeight={sidebarHeight}
//                 setIsOpenFeedBack={setIsOpenFeedBack}
//                 feedBackHandler={surveyFeedBackHandler}
//                 lang={lang}
//                 arPhrase={arPhrase}
//                 enPhrase={enPhrase}
//               />
//             )
//           ) : isSueveyMenu ? (
//             <div
//               className={`w-full md:w-[400px] border-[1px] border-[#E6D7A2] bg-[#fff] ${
//                 isOpenFeedBack ? "fixed" : "hidden"
//               } ${
//                 !isExpand
//                   ? `bottom-[0px] overflow-y-scroll ${
//                       lang === "en" ? "right-0" : "left-0"
//                     }`
//                   : `bottom-[35px] ${
//                       lang === "en"
//                         ? "right-0 md:right-[24px]"
//                         : "left-0 md:left-[24px]"
//                     }`
//               } z-[10000]`}
//               style={{ top: sidebarHeight }}
//             >
//               <div className="h-[56px] bg-[#F2ECCF] flex items-center justify-between gap-[16px] px-[16px] fixed w-full md:w-[400px]">
//                 <div>
//                   <div className="flex flex-col gap-[5px]">
//                     <div className="font-Almarai font-normal text-[14px] leading-[14.4px] flex gap-[8px]">
//                       <span className="font-normal">{service?.id}</span>
//                       <span>•</span>
//                       <p className="font-bold">{service?.serviceCategory}</p>
//                     </div>
//                     <div className="font-Almarai text-[12px] leading-[14.4px] flex gap-[8px] text-[#54504A]">
//                       <span>{service?.caseNumber?.slice(-12)}</span>
//                       <span>•</span>
//                       <p>{service?.caseTypeName}</p>
//                     </div>
//                   </div>
//                 </div>

//                 <img
//                   src="/assets/img/case-overview/closedIcon.svg"
//                   alt="close-icon"
//                   className="cursor-pointer transform transition-transform duration-500 ease-in-out hover:scale-110 hover:bg-[#a9803133] rounded"
//                   onClick={() => {
//                     setIsSueveyMenu(false);
//                   }}
//                 />
//               </div>

//               <div className="flex flex-col items-center w-full p-[16px] pt-[72px]">
//                 <div className="h-[72px] w-full m-auto border-[1px] border-[#F2C99B] p-[16px] rounded-[8px] flex items-center gap-[24px]">
//                   <img
//                     src="/assets/img/case-overview/survay-icon.svg"
//                     alt=""
//                     className="w-[32px] h-[32px]"
//                   />
//                   <p
//                     className={`flex font-Almarai font-bold text-[14px] leading-[20px] ${
//                       lang === "en" ? "text-left" : "text-right"
//                     }`}
//                   >
//                     {lang === "en"
//                       ? enPhrase["lblShareSurveytext"]
//                       : arPhrase["lblShareSurveytext"]}
//                   </p>
//                 </div>

//                 <FeedBackQuestions
//                   lang={lang}
//                   enPhrase={enPhrase}
//                   arPhrase={arPhrase}
//                   selectedServiceId={service?.id}
//                   onSuccessChange={handleSuccessChange}
//                 />
//               </div>
//             </div>
//           ) : null}

//           {(service?.serviceStatusId === 6 ||
//             service?.serviceStatusId === 7) && (
//             <div
//               className={`flex items-stretch border-solid border-2 ${
//                 service?.serviceStatusId === 7
//                   ? "border-[#FF9280]"
//                   : "border-[#C3C1BB]"
//               } rounded shadow-[0px_10px_40px_#361E1214] mb-6`}
//             >
//               <div
//                 className={`w-[20px] border-4 flex justify-center items-center ${
//                   service?.serviceStatusId === 7
//                     ? "border-[#FF9280] bg-[#FF9280]"
//                     : "border-[#C3C1BB] bg-[#C3C1BB]"
//                 }`}
//               >
//                 <div
//                   className={`w-[8px] min-h-[58px] h-full border-2 bg-[#fff] rounded ${
//                     service?.serviceStatusId === 7
//                       ? "border-[#FF9280]"
//                       : "border-[#C3C1BB]"
//                   }`}
//                 ></div>
//               </div>

//               <div className="flex flex-col px-4 py-2 justify-center w-full">
//                 <h2 className="text-[16px] text-[#010202] md:mb-[8px]">
//                   {service?.status} :
//                 </h2>
//                 <p className="text-base text-[#010202] font-bold">
//                   {service?.suspendReason}
//                 </p>
//               </div>
//             </div>
//           )}

//           <div className="flex flex-col xl:flex-row-reverse gap-8 items-start justify-center">
//             <div
//               className={`flex flex-col w-full ${
//                 service?.serviceStatusId === 1 ||
//                 service?.serviceStatusId === 8 ||
//                 service?.serviceStatusId === 2
//                   ? "xl:w-full"
//                   : "xl:w-[35%]"
//               } justify-start gap-[16px] mb-[12px] items-center`}
//             >
//               <Disclosure
//                 as="div"
//                 className="w-full bg-[#A9803114] border-[0.5px] border-[#EEE2D0] shadow-[0px_10px_40px_#361E1214] rounded-[16px] flex flex-col items-center gap-[24px]"
//                 defaultOpen={true}
//               >
//                 {({ open }) => (
//                   <div className="w-full">
//                     <Disclosure.Button className="group flex w-full items-center justify-between px-[20px] h-[52px]">
//                       <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#361E12]">
//                         {lang === "en"
//                           ? enPhrase["lblApplicationDetails"]
//                           : arPhrase["lblApplicationDetails"]}
//                       </p>

//                       <div className="flex items-center justify-center gap-2">
//                         <img
//                           src="/assets/img/add-request/dash.svg"
//                           alt="dash"
//                           className="w-[1px] h-[20px]"
//                         />
//                         <img
//                           className={`size-5 transition-transform duration-500 ease-in-out ${
//                             open ? "rotate-0" : "rotate-180"
//                           }`}
//                           src="/assets/img/add-request/ArrowUP.svg"
//                           alt="arrow"
//                         />
//                       </div>
//                     </Disclosure.Button>

//                     <Transition
//                       show={open}
//                       enter="transition-all duration-700 ease-in-out"
//                       enterFrom="max-h-0 opacity-0"
//                       enterTo="opacity-100"
//                       leave="transition-all duration-500 ease-in-out"
//                       leaveFrom="opacity-100"
//                       leaveTo="max-h-0 opacity-0"
//                       className="overflow-hidden flex items-center justify-center"
//                     >
//                       <Disclosure.Panel
//                         static
//                         className={`${
//                           window && window.innerWidth <= 768
//                             ? "mx-[4px] mb-[4px] w-[99%]"
//                             : "mx-[8px] mb-[8px] w-[99%]"
//                         } rounded-[12px] border-[0.5px] border-solid border-[#D4D2CE] bg-[#fff] shadow-[0px_10px_40px_#351F131F] p-[16px] gap-[16px] flex flex-col transition-all duration-500 ease-in-out overflow-visible`}
//                       >
//                         {window && window.innerWidth <= 768 ? (
//                           <div>
//                             <OrderDetailsSectionLatestMobile
//                               service={service}
//                               lang={lang}
//                               arPhrase={arPhrase}
//                               enPhrase={enPhrase}
//                             />
//                           </div>
//                         ) : (
//                           <div>
//                             <OrderDetailsSectionLatest
//                               service={service}
//                               lang={lang}
//                               arPhrase={arPhrase}
//                               enPhrase={enPhrase}
//                             />
//                           </div>
//                         )}
//                       </Disclosure.Panel>
//                     </Transition>
//                   </div>
//                 )}
//               </Disclosure>

//               <Disclosure
//                 as="div"
//                 className="w-full bg-[#A9803114] border-[0.5px] border-[#EEE2D0] shadow-[0px_10px_40px_#361E1214] rounded-[16px] flex flex-col items-center gap-[24px]"
//                 defaultOpen={true}
//               >
//                 {({ open }) => (
//                   <div className="w-full">
//                     <Disclosure.Button className="group flex w-full items-center justify-between px-[20px] h-[52px]">
//                       <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#361E12]">
//                         {lang === "en"
//                           ? enPhrase["lblCaseDetails"]
//                           : arPhrase["lblCaseDetails"]}
//                       </p>

//                       <div className="flex items-center justify-center gap-2">
//                         <img
//                           src="/assets/img/add-request/dash.svg"
//                           alt="dash"
//                           className="w-[1px] h-[20px]"
//                         />
//                         <img
//                           className={`size-5 transition-transform duration-500 ease-in-out ${
//                             open ? "rotate-0" : "rotate-180"
//                           }`}
//                           src="/assets/img/add-request/ArrowUP.svg"
//                           alt="arrow"
//                         />
//                       </div>
//                     </Disclosure.Button>

//                     <Transition
//                       show={open}
//                       enter="transition-all duration-700 ease-in-out"
//                       enterFrom="max-h-0 opacity-0"
//                       enterTo="opacity-100"
//                       leave="transition-all duration-500 ease-in-out"
//                       leaveFrom="opacity-100"
//                       leaveTo="max-h-0 opacity-0"
//                       className="overflow-hidden flex items-center justify-center"
//                     >
//                       <Disclosure.Panel
//                         static
//                         className={`${
//                           window && window.innerWidth <= 768
//                             ? "mx-[4px] mb-[4px]"
//                             : "mx-[8px] mb-[8px]"
//                         } w-[99%] rounded-[12px] border-[0.5px] border-solid border-[#D4D2CE] bg-[#fff] shadow-[0px_10px_40px_#351F131F] p-[16px] gap-[16px] flex flex-col transition-all duration-500 ease-in-out overflow-visible`}
//                       >
//                         {window && window.innerWidth <= 768 ? (
//                           <CaseDetailsSectionLatestMobile
//                             service={service}
//                             lang={lang}
//                             arPhrase={arPhrase}
//                             enPhrase={enPhrase}
//                           />
//                         ) : (
//                           <CaseDetailsSectionLatest
//                             service={service}
//                             lang={lang}
//                             arPhrase={arPhrase}
//                             enPhrase={enPhrase}
//                           />
//                         )}
//                       </Disclosure.Panel>
//                     </Transition>
//                   </div>
//                 )}
//               </Disclosure>
//             </div>

//             {(service?.serviceStatusId === 3 ||
//               service?.serviceStatusId === 4 ||
//               service?.serviceStatusId === 5 ||
//               service?.serviceStatusId === 6 ||
//               service?.serviceStatusId === 7) && (
//               <div className="w-full xl:w-[68%]">
//                 <div className="flex flex-col w-full gap-0 md:gap-0 mb-8 overflow-hidden border-2 border-solid border-[#EEE2D0] rounded shadow-[0px_10px_40px_#361E1214]">
//                   <div className="w-full">
//                     <ServiceValue
//                       service={service}
//                       claimedValue={service?.serviceValue}
//                       serviceStatusId={service?.serviceStatusId}
//                       setOpenModal={setOpenModal}
//                       successUploadReciept={successUploadReciept}
//                     />
//                   </div>
//                   <div className="w-full py-[16px] md:py-[0px]">
//                     <ServiceDetails
//                       serviceDescription={service?.serviceDescription}
//                       service={service}
//                       lang={lang}
//                       arPhrase={arPhrase}
//                       enPhrase={enPhrase}
//                     />
//                   </div>
//                 </div>

//                 {service?.subjectDocuments?.length > 0 &&
//                   service?.serviceStatusId === 3 && (
//                     <div
//                       className="bg-white  border-2 !border-[#EEE2D0] rounded p-6.5 shadow-[0_4px_20px_rgba(40,32,14,0.03)] py-3 px-4"
//                       id="doc"
//                     >
//                       <div className="pb-4">
//                         <h2 className="text-base font-bold text-[#1a1712] font-Almarai">
//                           {lang === "ar" ? "المستندات" : "Documents"}
//                         </h2>
//                         <p className="text-xs text-[#6d6453] mt-0.5 font-Almarai">
//                           {lang === "ar"
//                             ? "المستندات المرفقة بهذا الطلب ."
//                             : "Documents attached to this request ."}
//                         </p>
//                       </div>

//                       {service?.courtDocumentUrl && (
//                         <div className="group mt-2 rounded-2xl border !border-[#EEE2D0] bg-white hover:bg-[#FAF7EF] p-4 flex justify-between items-center">
//                           <div className="flex items-center gap-3">
//                             <div className="w-11 h-11 rounded-xl bg-[#FBF7EE] flex items-center justify-center">
//                               <img
//                                 src="/assets/img/documentrequest.svg"
//                                 width={24}
//                                 height={24}
//                                 alt="file"
//                                 aria-hidden="true"
//                                 className="transition-all duration-300 filter-[invert(39%)_sepia(49%)_saturate(857%)_hue-rotate(16deg)_brightness(93%)_contrast(89%)]"
//                               />
//                             </div>

//                             <div>
//                               <p className="font-normal text-sm max-w-[120px] md:max-w-[320px] truncate">
//                                 {service.courtDocumentName}
//                               </p>
//                             </div>
//                           </div>

//                           <button
//                             type="button"
//                             onClick={() =>
//                               setSelectedDoc({
//                                 fileName: service?.courtDocumentName,
//                                 fileUrl: service?.courtDocumentUrl,
//                               })
//                             }
//                             className="min-w-[40px] h-[40px] rounded-[4px] border-[1px] border-solid border-[#B68A35] bg-[#fff] flex items-center justify-center gap-[8px] md:gap-0"
//                           >
//                             <img
//                               src="/assets/img/add-request/Show.svg"
//                               width={17}
//                               height={17}
//                               alt="view"
//                               aria-hidden="true"
//                               className="transition-all duration-300 filter-[invert(39%)_sepia(49%)_saturate(857%)_hue-rotate(16deg)_brightness(93%)_contrast(89%)]"
//                             />
//                           </button>
//                         </div>
//                       )}

//                       {service?.subjectDocuments?.map((doc, id) => {
//                         return (
//                           <div
//                             key={id}
//                             className="group mt-2 rounded-2xl border !border-[#EEE2D0] bg-white hover:bg-[#FAF7EF] p-4 flex justify-between items-center"
//                           >
//                             <div className="flex items-center gap-3">
//                               <div className="w-11 h-11 rounded-xl bg-[#FBF7EE] flex items-center justify-center">
//                                 <img
//                                   src="/assets/img/documentrequest.svg"
//                                   width={24}
//                                   height={24}
//                                   alt="file"
//                                   aria-hidden="true"
//                                   className="transition-all duration-300 filter-[invert(39%)_sepia(49%)_saturate(857%)_hue-rotate(16deg)_brightness(93%)_contrast(89%)]"
//                                 />
//                               </div>

//                               <div>
//                                 <p className="font-normal text-sm max-w-[120px] md:max-w-[320px] truncate">
//                                   {doc.fileName}
//                                 </p>
//                               </div>
//                             </div>

//                             <button
//                               type="button"
//                               onClick={() => setSelectedDoc(doc)}
//                               className="min-w-[40px] h-[40px] rounded-[4px] border-[1px] border-solid border-[#B68A35] bg-[#fff] flex items-center justify-center gap-[8px] md:gap-0"
//                             >
//                               <img
//                                 src={"/assets/img/add-request/Show.svg"}
//                                 width={17}
//                                 height={17}
//                                 alt="view"
//                                 aria-hidden="true"
//                                 className="transition-all duration-300 filter-[invert(39%)_sepia(49%)_saturate(857%)_hue-rotate(16deg)_brightness(93%)_contrast(89%)]"
//                               />
//                             </button>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//               </div>
//             )}
//           </div>

//           {(service?.serviceStatusId === 2 ||
//             service?.serviceStatusId === 5 ||
//             service?.serviceStatusId === 6 ||
//             service?.serviceStatusId === 7) &&
//           comments.length > 0 ? (
//             <div>
//               <SmallTitle
//                 title={
//                   lang === "en"
//                     ? enPhrase["lblFilesTracking"]
//                     : arPhrase["lblFilesTracking"]
//                 }
//               />
//               <div className="flex flex-col overflow-hidden border-2 border-solid border-[#EEE2D0] rounded shadow-[0px_10px_40px_#361E1214]">
//                 {comments
//                   ?.slice(0)
//                   .reverse()
//                   ?.map((comment, indx) => (
//                     <div key={indx}>
//                       <div className="flex gap-2 text-[12px] text-[#010202] font-medium bg-[#EEE2D0] h-[30px] leading-[30px] px-4">
//                         <span className="text-[12px] font-Almarai font-bold">
//                           {comment?.name}
//                         </span>
//                         <span>•</span>
//                         <span className="text-[12px] font-Almarai font-bold">
//                           {new Date(comment?.createdAt).toLocaleDateString(
//                             "en-GB",
//                           )}
//                         </span>
//                       </div>
//                       <div className="px-4">
//                         <div className="flex flex-row justify-between gap-20 py-4">
//                           <p className="text-sm text-[#010202] font-medium max-w-full overflow-clip overflow-x-clip">
//                             {comment?.commentText}
//                           </p>
//                           {indx === 0 &&
//                           comment?.name &&
//                           service?.serviceStatusId === 2 ? (
//                             <button
//                               type="button"
//                               className="inline-flex justify-center gap-2 items-center h-[44px] rounded-md border border-transparent bg-gold-100 py-4 px-8 text-sm font-bold text-white shadow-sm"
//                               onClick={handelOpenPopup}
//                             >
//                               <span>{lang === "en" ? "Reply" : "رد"}</span>
//                             </button>
//                           ) : (
//                             ""
//                           )}
//                         </div>
//                         <div className="flex gap-4 mb-4">
//                           {comment?.documents?.map((el, index) => (
//                             <React.Fragment key={index}>
//                               {el?.documentUrl.includes("pdf") === true ? (
//                                 <div className="w-[179px] h-[130px] rounded">
//                                   <embed
//                                     src={el?.documentUrl}
//                                     height="100%"
//                                     width="100%"
//                                   ></embed>
//                                 </div>
//                               ) : (
//                                 <img
//                                   className="w-[179px] h-[130px] rounded"
//                                   src={el?.documentUrl}
//                                   alt=""
//                                 />
//                               )}
//                             </React.Fragment>
//                           ))}
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           ) : null}

//           {/* Modal for viewing documents from subjectDocuments */}
//           {Boolean(selectedDoc) && (
//             <SharedModal
//               showImage
//               openModal={Boolean(selectedDoc)}
//               setOpenModal={() => setSelectedDoc(null)}
//             >
//               <div className="w-full rounded-t-[16px]">
//                 {/* Header bar */}
//                 <div className="h-[56px] w-full flex items-center justify-between px-[24px] bg-[#eee2d0]">
//                   <span className="font-bold text-sm text-[#361E12] truncate max-w-[80%]">
//                     {selectedDoc?.fileName}
//                   </span>
//                   <img
//                     src="/assets/img/close.svg"
//                     alt="close"
//                     className="cursor-pointer h-5 w-5"
//                     onClick={() => setSelectedDoc(null)}
//                   />
//                 </div>

//                 {/* Document Content View */}
//                 {selectedDoc?.fileName?.toLowerCase().endsWith(".pdf") ||
//                 selectedDoc?.fileUrl?.toLowerCase().includes(".pdf") ? (
//                   <iframe
//                     src={`${selectedDoc?.fileUrl}#toolbar=0&navpanes=0`}
//                     title="PDF Document Viewer"
//                     className="w-full h-[550px] border-none rounded-b-[16px]"
//                   />
//                 ) : (
//                   <div className="flex items-center justify-center p-4 bg-white rounded-b-[16px]">
//                     <img
//                       className="max-w-full max-h-[500px] object-contain rounded-b-[16px]"
//                       alt="document view"
//                       src={selectedDoc?.fileUrl}
//                     />
//                   </div>
//                 )}
//               </div>
//             </SharedModal>
//           )}

//           {openModal && (
//             <SharedModal isPaymentConfirm setOpenModal={setOpenModal}>
//               <ConfirmPayment
//                 claimedValue={USDollar.format(service?.serviceValue)}
//                 setOpenModal={setOpenModal}
//                 service={service}
//                 caseid={serviceid}
//                 serviceid={caseid}
//                 setOpenModalFail={setOpenModalFail}
//                 setOpenModalSucc={setOpenModalSucc}
//               />
//             </SharedModal>
//           )}

//           {openModalFail && (
//             <SharedModal setOpenModal={setOpenModalFail}>
//               <FailedPayment setOpenModal={setOpenModalFail} />
//             </SharedModal>
//           )}

//           {openModalSucc && (
//             <SharedModal setOpenModal={setOpenModalSucc}>
//               <SuccessPayment setOpenModal={setOpenModalSucc} />
//             </SharedModal>
//           )}

//           {openPopub && (
//             <SharedModal isNeedData setOpenModal={handelOpenPopup}>
//               <PopupForm
//                 handelOpenPopup={handelOpenPopup}
//                 getCommentsService={getCommentsService}
//                 serviceid={serviceid}
//                 setOpenPopub={setOpenPopub}
//               />
//             </SharedModal>
//           )}

//           {receiptStatus && (
//             <SharedModal isReceiptForm setOpenModal={uploadReceiptHandler}>
//               <ReceiptForm
//                 uploadReceiptHandler={uploadReceiptHandler}
//                 setReceiptStatus={setReceiptStatus}
//                 receiptStatus={receiptStatus}
//                 service={service}
//                 successUploadReciept={successUploadReciept}
//                 setSuccessUploadReciept={setSuccessUploadReciept}
//                 falidUploadReciept={falidUploadReciept}
//                 setFalidUploadReciept={setFalidUploadReciept}
//               />
//             </SharedModal>
//           )}
//         </div>
//       )}
//     </ThemeLayout>
//   );
// };

// export default OrderDetails;



import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import Breadcrumb from "../components/breadCrumb";
import LargeTitle from "../components/case-tracking/LargeTitle";
import PopupForm from "../components/case-tracking/PopupForm";
import ReceiptForm from "../components/case-tracking/ReceiptForm";
import ServiceDetails from "../components/case-tracking/ServiceDetails";
import ServiceDetailsPart1 from "../components/case-tracking/ServiceDetailsPart1";
import ServiceDetailsPart1DeskTop from "../components/case-tracking/ServiceDetailsPart1DeskTop";
import ServiceDetailsPart2 from "../components/case-tracking/ServiceDetailsPart2";
import ServiceValue from "../components/case-tracking/ServiceValue";
import SmallTitle from "../components/case-tracking/SmallTitle";
import SharedModal from "../components/happiness/SharedModal";
import ConfirmPayment from "../components/paymentPopup/ConfirmPayment";
import FailedPayment from "../components/paymentPopup/FailedPayment";
import SuccessPayment from "../components/paymentPopup/SuccessPayment";
import { PhrasesContext } from "../context/phrasesContext";
import ThemeLayout from "../layouts/ThemeLayout";
import {
  getComments,
  getServiceDetails,
  getCancel_Request,
} from "../services/Common";
import { USDollar } from "../utils/helpers";
import FeedBackQuestions from "../components/FeedBack/FeedBackQuestions";
import SuccessSurvayAdded from "../components/FeedBack/SuccessSurvayAdded";
import SuccessSurvayAddedMobile from "../components/FeedBack/SuccessSurvayAddedMobile";
import { Loader } from "../components/utils";
import { Disclosure, Transition } from "@headlessui/react";
import OrderDetailsSectionLatest from "../components/case-tracking/OrderDetailsSectionLatest";
import CaseDetailsSectionLatest from "../components/case-tracking/CaseDetailsSectionLatest";
import OrderDetailsSectionLatestMobile from "../components/case-tracking/OrderDetailsSectionLatestMobile";
import CaseDetailsSectionLatestMobile from "../components/case-tracking/CaseDetailsSectionLatestMobile";

// Sub-component to safely fetch and render PDF files using Blob URL or Google Docs Fallback
const PdfViewer = ({ fileUrl, lang }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let isMounted = true;
    let currentBlobUrl = null;

    setLoading(true);
    setError(false);

    fetch(fileUrl)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch PDF");
        return res.blob();
      })
      .then((blob) => {
        if (isMounted) {
          const pdfBlob = new Blob([blob], { type: "application/pdf" });
          currentBlobUrl = URL.createObjectURL(pdfBlob);
          setBlobUrl(currentBlobUrl);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("PDF Fetch Error:", err);
        if (isMounted) {
          setError(true);
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
      if (currentBlobUrl) {
        URL.revokeObjectURL(currentBlobUrl);
      }
    };
  }, [fileUrl]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-[500px] bg-white rounded-b-[16px]">
        <Loader color="#b68a35" />
        <p className="text-[#b68a35] font-bold font-Almarai mt-4 text-sm">
          {lang === "en" ? "Loading Document..." : "جاري تحميل المستند..."}
        </p>
      </div>
    );
  }

  if (error || !blobUrl) {
    return (
      <div className="flex flex-col items-center justify-center h-[228px] md:h-[500px] bg-white  text-center rounded-b-[16px]">
        <iframe
          src={`https://docs.google.com/viewer?url=${encodeURIComponent(
            fileUrl
          )}&embedded=true`}
          title="Google Docs PDF Viewer"
          className="w-full h-full border-none rounded-b-[16px]"
          onError={() => setError(true)}
        />
      </div>
    );
  }

  return (
    <iframe
      src={`${blobUrl}#toolbar=0&navpanes=0`}
      title="PDF Viewer"
      className="w-full h-[500px] border-none rounded-b-[16px]"
    />
  );
};

const OrderDetails = () => {
  const { caseid, serviceid } = useParams();
  const [lang, setLang] = useState("");
  const [service, setService] = useState({});
  const [comments, setComments] = useState([]);
  const [openPopub, setOpenPopub] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [receiptStatus, setReceiptStatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [successUploadReciept, setSuccessUploadReciept] = useState(false);
  const [falidUploadReciept, setFalidUploadReciept] = useState(false);
  const [openModalFail, setOpenModalFail] = useState(false);
  const [openModalSucc, setOpenModalSucc] = useState(false);

  const [isSueveyMenu, setIsSueveyMenu] = useState(false);
  const [isOpenFeedBack, setIsOpenFeedBack] = useState(true);
  const [isExpand, setIsExpand] = useState(false);
  const [success, setSuccess] = useState("");

  const [sidebarHeight, setSidebarHeight] = useState(0);
  const navbarRef = useRef(null);
  const [isOpenPopup, setIsOpenPopup] = useState(false);

  const [enPhrase, arPhrase] = useContext(PhrasesContext);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [uploadedFile, setUploadedFile] = useState("");
  const [file, setFile] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const lang = window.localStorage.getItem("lang");
    let currentLang = lang;
    if (lang === "en") {
      document.body.dir = "ltr";
      setLang("en");
      currentLang = "en";
    } else {
      document.body.dir = "rtl";
      setLang("ar");
      currentLang = "ar";
    }
    getServiceDetailsService(currentLang);
    getCommentsService(currentLang);
  }, []);

  const getServiceDetailsService = (currentLang) => {
    return getServiceDetails(caseid, serviceid, currentLang).then((res) => {
      setService(res);
      setLoading(false);
    });
  };

  const getCommentsService = (currentLang) => {
    return getComments(serviceid, currentLang).then((res) => {
      setComments(res);
    });
  };

  const handelOpenPopup = () => {
    setOpenPopub(!openPopub);
  };

  const uploadReceiptHandler = () => {
    setReceiptStatus(!receiptStatus);
  };

  const surveyFeedBackHandler = () => {
    setIsSueveyMenu(!isSueveyMenu);
  };

  const handleSuccessChange = (newState) => {
    setSuccess(newState);
  };

  useEffect(() => {
    if (navbarRef.current) {
      setSidebarHeight(navbarRef.current.offsetHeight);
    }
  }, [navbarRef]);

  const confirmCancel = () => {
    setLoadingSpinner(true);
    getCancel_Request(lang, serviceid).then(
      (res) => {
        if (res?.isSuccess) {
          setLoading(false);
          navigate("/case-overview");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setLoadingSpinner(false);
          return;
        }
      },
      (error) => {
        console.error("Error submitting form", error);
        window.scrollTo({ top: 0, behavior: "smooth" });
        setLoading(false);
      }
    );
  };

  return (
    <ThemeLayout navbarRef={navbarRef}>
      {loading ? (
        <p className="text-[#b68a35] font-bold font-Almarai mt-[8px]">
          {lang === "en" ? "Loading..." : "جاري عرض البيانات..."}
        </p>
      ) : (
        <div className="flex flex-col w-full py-4 max-w-[1440px] px-[16px] lg:px-[0px]">
          <Breadcrumb
            title={
              lang === "en" ? enPhrase["lblMycases"] : arPhrase["lblMycases"]
            }
            subtitle1={`${service?.caseNumber || ""}`}
            subtitle1Href={`${
              service?.caseId === 0
                ? "/case-overview"
                : `/case-details/${service?.caseId}`
            }`}
            last={`${
              lang === "en"
                ? `${enPhrase["lblRequest"]} ${service?.id}`
                : `${service?.id} ${arPhrase["lblRequest"]}`
            }`}
            lastHref={`/order-details/${service?.caseId}/${service?.id}`}
          />
          <div className="flex justify-between items-center mb-[24px] md:mb-8">
            <div className="flex flex-col xxsm:flex-row justify-between items-center gap-2 capitalize ">
              <LargeTitle
                title={
                  lang === "en"
                    ? enPhrase["lblDetails"]
                    : arPhrase["lblDetails"]
                }
                nullmargin
              />
            </div>
            {service?.serviceStatusId === 5 && !service?.completeSurvey ? (
              <button
                className="w-[166px] h-[44px] bg-[#A98031] rounded text-[#fff] font-Almarai font-bold text-[16px] px-3"
                onClick={surveyFeedBackHandler}
              >
                <p>
                  {lang === "en"
                    ? enPhrase["btnSurvey"]
                    : arPhrase["btnSurvey"]}
                </p>
              </button>
            ) : (
              (service?.serviceStatusId === 1 ||
                (service?.serviceStatusId === 3 &&
                  service?.isUploadReceipts === false &&
                  service?.isPaid === false)) && (
                <button
                  onClick={() => setIsOpenPopup(true)}
                  className="md:w-[156px] h-[44px] md:bg-[#FFFFFF] rounded md:border md:border-solid md:!border-[#E23636] text-[#E23636] font-Almarai font-bold text-[14px] md:text-[16px] md:px-3"
                >
                  <p>
                    {lang === "en"
                      ? enPhrase["lblConfirmCancelRequest"]
                      : arPhrase["lblConfirmCancelRequest"]}
                  </p>
                </button>
              )
            )}
          </div>

          {isOpenPopup && (
            <SharedModal
              isDeleteConfirmation
              setOpenModal={setIsOpenPopup}
              openModal={isOpenPopup}
            >
              <div
                className="flex flex-col items-center gap-[32px] md:gap-[40px] py-[24px] md:py-[32px] px-[24px] md:px-[40px]"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src="/assets/img/Caution.svg"
                  alt="aleart"
                  className="w-[64px] md:w-[80px] h-[52px] md:h-[65.5px]"
                />

                <p className="font-Almarai font-[400] text-[16px] md:text-[24px] leading-[24px] md:leading-[36px] text-[#010202]">
                  {lang === "en"
                    ? enPhrase["lblConfirmCancelRequestTxt"]
                    : arPhrase["lblConfirmCancelRequestTxt"]}
                </p>
                <div className="w-full flex flex-col-reverse md:flex-row justify-center gap-[16px]">
                  <button
                    className="w-full md:w-[50%] h-[44px] rounded-[4px] px-[16px] bg-[#F2ECCF]"
                    onClick={() => setIsOpenPopup(false)}
                  >
                    <p className="font-Almarai font-bold text-[16px] leading-[20px] text-[#815327]">
                      {lang === "en"
                        ? enPhrase["lblGoBackText"]
                        : arPhrase["lblGoBackText"]}
                    </p>
                  </button>
                  <button
                    className="w-full md:w-[50%] h-[44px] rounded-[4px] px-[16px] bg-[#B68A35] flex items-center justify-center gap-2"
                    onClick={confirmCancel}
                  >
                    <p className="font-Almarai font-bold text-[16px] leading-[20px] text-[#fff]">
                      {lang === "en"
                        ? enPhrase["lblConfirm"]
                        : arPhrase["lblConfirm"]}
                    </p>
                    {loadingSpinner && <Loader color={"white"} />}
                  </button>
                </div>
              </div>
            </SharedModal>
          )}

          {success ? (
            window && window.innerWidth <= 1024 ? (
              <SharedModal isSuccessSurvayMobile setOpenModal={setSuccess}>
                <SuccessSurvayAddedMobile
                  isOrderDetails
                  sidebarHeight={sidebarHeight}
                  setIsOpenFeedBack={setIsOpenFeedBack}
                  feedBackHandler={surveyFeedBackHandler}
                  lang={lang}
                  arPhrase={arPhrase}
                  enPhrase={enPhrase}
                />
              </SharedModal>
            ) : (
              <SuccessSurvayAdded
                isOrderDetails
                sidebarHeight={sidebarHeight}
                setIsOpenFeedBack={setIsOpenFeedBack}
                feedBackHandler={surveyFeedBackHandler}
                lang={lang}
                arPhrase={arPhrase}
                enPhrase={enPhrase}
              />
            )
          ) : isSueveyMenu ? (
            <div
              className={`w-full md:w-[400px] border-[1px] border-[#E6D7A2] bg-[#fff] ${
                isOpenFeedBack ? "fixed" : "hidden"
              } ${
                !isExpand
                  ? `bottom-[0px] overflow-y-scroll ${
                      lang === "en" ? "right-0" : "left-0"
                    }`
                  : `bottom-[35px] ${
                      lang === "en"
                        ? "right-0 md:right-[24px]"
                        : "left-0 md:left-[24px]"
                    }`
              } z-[10000]`}
              style={{ top: sidebarHeight }}
            >
              <div className="h-[56px] bg-[#F2ECCF] flex items-center justify-between gap-[16px] px-[16px] fixed w-full md:w-[400px]">
                <div>
                  <div className="flex flex-col gap-[5px]">
                    <div className="font-Almarai font-normal text-[14px] leading-[14.4px] flex gap-[8px]">
                      <span className="font-normal">{service?.id}</span>
                      <span>•</span>
                      <p className="font-bold">{service?.serviceCategory}</p>
                    </div>
                    <div className="font-Almarai text-[12px] leading-[14.4px] flex gap-[8px] text-[#54504A]">
                      <span>{service?.caseNumber?.slice(-12)}</span>
                      <span>•</span>
                      <p>{service?.caseTypeName}</p>
                    </div>
                  </div>
                </div>

                <img
                  src="/assets/img/case-overview/closedIcon.svg"
                  alt="close-icon"
                  className="cursor-pointer transform transition-transform duration-500 ease-in-out hover:scale-110 hover:bg-[#a9803133] rounded"
                  onClick={() => {
                    setIsSueveyMenu(false);
                  }}
                />
              </div>

              <div className="flex flex-col items-center w-full p-[16px] pt-[72px]">
                <div className="h-[72px] w-full m-auto border-[1px] border-[#F2C99B] p-[16px] rounded-[8px] flex items-center gap-[24px]">
                  <img
                    src="/assets/img/case-overview/survay-icon.svg"
                    alt=""
                    className="w-[32px] h-[32px]"
                  />
                  <p
                    className={`flex font-Almarai font-bold text-[14px] leading-[20px] ${
                      lang === "en" ? "text-left" : "text-right"
                    }`}
                  >
                    {lang === "en"
                      ? enPhrase["lblShareSurveytext"]
                      : arPhrase["lblShareSurveytext"]}
                  </p>
                </div>

                <FeedBackQuestions
                  lang={lang}
                  enPhrase={enPhrase}
                  arPhrase={arPhrase}
                  selectedServiceId={service?.id}
                  onSuccessChange={handleSuccessChange}
                />
              </div>
            </div>
          ) : null}

          {(service?.serviceStatusId === 6 ||
            service?.serviceStatusId === 7) && (
            <div
              className={`flex items-stretch border-solid border-2 ${
                service?.serviceStatusId === 7
                  ? "border-[#FF9280]"
                  : "border-[#C3C1BB]"
              } rounded shadow-[0px_10px_40px_#361E1214] mb-6`}
            >
              <div
                className={`w-[20px] border-4 flex justify-center items-center ${
                  service?.serviceStatusId === 7
                    ? "border-[#FF9280] bg-[#FF9280]"
                    : "border-[#C3C1BB] bg-[#C3C1BB]"
                }`}
              >
                <div
                  className={`w-[8px] min-h-[58px] h-full border-2 bg-[#fff] rounded ${
                    service?.serviceStatusId === 7
                      ? "border-[#FF9280]"
                      : "border-[#C3C1BB]"
                  }`}
                ></div>
              </div>

              <div className="flex flex-col px-4 py-2 justify-center w-full">
                <h2 className="text-[16px] text-[#010202] md:mb-[8px]">
                  {service?.status} :
                </h2>
                <p className="text-base text-[#010202] font-bold">
                  {service?.suspendReason}
                </p>
              </div>
            </div>
          )}

          <div className="flex flex-col xl:flex-row-reverse gap-8 items-start justify-center">
            <div
              className={`flex flex-col w-full ${
                service?.serviceStatusId === 1 ||
                service?.serviceStatusId === 8 ||
                service?.serviceStatusId === 2
                  ? "xl:w-full"
                  : "xl:w-[35%]"
              } justify-start gap-[16px] mb-[12px] items-center`}
            >
              <Disclosure
                as="div"
                className="w-full bg-[#A9803114] border-[0.5px] border-[#EEE2D0] shadow-[0px_10px_40px_#361E1214] rounded-[16px] flex flex-col items-center gap-[24px]"
                defaultOpen={true}
              >
                {({ open }) => (
                  <div className="w-full">
                    <Disclosure.Button className="group flex w-full items-center justify-between px-[20px] h-[52px]">
                      <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#361E12]">
                        {lang === "en"
                          ? enPhrase["lblApplicationDetails"]
                          : arPhrase["lblApplicationDetails"]}
                      </p>

                      <div className="flex items-center justify-center gap-2">
                        <img
                          src="/assets/img/add-request/dash.svg"
                          alt="dash"
                          className="w-[1px] h-[20px]"
                        />
                        <img
                          className={`size-5 transition-transform duration-500 ease-in-out ${
                            open ? "rotate-0" : "rotate-180"
                          }`}
                          src="/assets/img/add-request/ArrowUP.svg"
                          alt="arrow"
                        />
                      </div>
                    </Disclosure.Button>

                    <Transition
                      show={open}
                      enter="transition-all duration-700 ease-in-out"
                      enterFrom="max-h-0 opacity-0"
                      enterTo="opacity-100"
                      leave="transition-all duration-500 ease-in-out"
                      leaveFrom="opacity-100"
                      leaveTo="max-h-0 opacity-0"
                      className="overflow-hidden flex items-center justify-center"
                    >
                      <Disclosure.Panel
                        static
                        className={`${
                          window && window.innerWidth <= 768
                            ? "mx-[4px] mb-[4px] w-[99%]"
                            : "mx-[8px] mb-[8px] w-[99%]"
                        } rounded-[12px] border-[0.5px] border-solid border-[#D4D2CE] bg-[#fff] shadow-[0px_10px_40px_#351F131F] p-[16px] gap-[16px] flex flex-col transition-all duration-500 ease-in-out overflow-visible`}
                      >
                        {window && window.innerWidth <= 768 ? (
                          <div>
                            <OrderDetailsSectionLatestMobile
                              service={service}
                              lang={lang}
                              arPhrase={arPhrase}
                              enPhrase={enPhrase}
                            />
                          </div>
                        ) : (
                          <div>
                            <OrderDetailsSectionLatest
                              service={service}
                              lang={lang}
                              arPhrase={arPhrase}
                              enPhrase={enPhrase}
                            />
                          </div>
                        )}
                      </Disclosure.Panel>
                    </Transition>
                  </div>
                )}
              </Disclosure>

              <Disclosure
                as="div"
                className="w-full bg-[#A9803114] border-[0.5px] border-[#EEE2D0] shadow-[0px_10px_40px_#361E1214] rounded-[16px] flex flex-col items-center gap-[24px]"
                defaultOpen={true}
              >
                {({ open }) => (
                  <div className="w-full">
                    <Disclosure.Button className="group flex w-full items-center justify-between px-[20px] h-[52px]">
                      <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#361E12]">
                        {lang === "en"
                          ? enPhrase["lblCaseDetails"]
                          : arPhrase["lblCaseDetails"]}
                      </p>

                      <div className="flex items-center justify-center gap-2">
                        <img
                          src="/assets/img/add-request/dash.svg"
                          alt="dash"
                          className="w-[1px] h-[20px]"
                        />
                        <img
                          className={`size-5 transition-transform duration-500 ease-in-out ${
                            open ? "rotate-0" : "rotate-180"
                          }`}
                          src="/assets/img/add-request/ArrowUP.svg"
                          alt="arrow"
                        />
                      </div>
                    </Disclosure.Button>

                    <Transition
                      show={open}
                      enter="transition-all duration-700 ease-in-out"
                      enterFrom="max-h-0 opacity-0"
                      enterTo="opacity-100"
                      leave="transition-all duration-500 ease-in-out"
                      leaveFrom="opacity-100"
                      leaveTo="max-h-0 opacity-0"
                      className="overflow-hidden flex items-center justify-center"
                    >
                      <Disclosure.Panel
                        static
                        className={`${
                          window && window.innerWidth <= 768
                            ? "mx-[4px] mb-[4px]"
                            : "mx-[8px] mb-[8px]"
                        } w-[99%] rounded-[12px] border-[0.5px] border-solid border-[#D4D2CE] bg-[#fff] shadow-[0px_10px_40px_#351F131F] p-[16px] gap-[16px] flex flex-col transition-all duration-500 ease-in-out overflow-visible`}
                      >
                        {window && window.innerWidth <= 768 ? (
                          <CaseDetailsSectionLatestMobile
                            service={service}
                            lang={lang}
                            arPhrase={arPhrase}
                            enPhrase={enPhrase}
                          />
                        ) : (
                          <CaseDetailsSectionLatest
                            service={service}
                            lang={lang}
                            arPhrase={arPhrase}
                            enPhrase={enPhrase}
                          />
                        )}
                      </Disclosure.Panel>
                    </Transition>
                  </div>
                )}
              </Disclosure>
            </div>

            {(service?.serviceStatusId === 3 ||
              service?.serviceStatusId === 4 ||
              service?.serviceStatusId === 5 ||
              service?.serviceStatusId === 6 ||
              service?.serviceStatusId === 7) && (
              <div className="w-full xl:w-[68%]">
                <div className="flex flex-col w-full gap-0 md:gap-0 mb-8 overflow-hidden border-2 border-solid border-[#EEE2D0] rounded shadow-[0px_10px_40px_#361E1214]">
                  <div className="w-full">
                    <ServiceValue
                      service={service}
                      claimedValue={service?.serviceValue}
                      serviceStatusId={service?.serviceStatusId}
                      setOpenModal={setOpenModal}
                      successUploadReciept={successUploadReciept}
                    />
                  </div>
                  <div className="w-full py-[16px] md:py-[0px]">
                    <ServiceDetails
                      serviceDescription={service?.serviceDescription}
                      service={service}
                      lang={lang}
                      arPhrase={arPhrase}
                      enPhrase={enPhrase}
                    />
                  </div>
                </div>

                {service?.subjectDocuments?.length > 0 &&
                  service?.serviceStatusId === 3 && (
                    <div
                      className="bg-white border-2 !border-[#EEE2D0] rounded p-6.5 shadow-[0_4px_20px_rgba(40,32,14,0.03)] py-3 px-4"
                      id="doc"
                    >
                      <div className="pb-4">
                        <h2 className="text-base font-bold text-[#1a1712] font-Almarai">
                          {lang === "ar" ? "المستندات" : "Documents"}
                        </h2>
                        <p className="text-xs text-[#6d6453] mt-0.5 font-Almarai">
                          {lang === "ar"
                            ? "المستندات المرفقة بهذا الطلب ."
                            : "Documents attached to this request ."}
                        </p>
                      </div>

                      {service?.subjectDocuments && (
                        <div className="group mt-2 rounded-2xl border !border-[#EEE2D0] bg-white hover:bg-[#FAF7EF] p-4 flex justify-between items-center">
                          <div className="flex items-center gap-3">
                            <div className="w-11 h-11 rounded-xl bg-[#FBF7EE] flex items-center justify-center">
                              <img
                                src="/assets/img/documentrequest.svg"
                                width={24}
                                height={24}
                                alt="file"
                                aria-hidden="true"
                                className="transition-all duration-300 filter-[invert(39%)_sepia(49%)_saturate(857%)_hue-rotate(16deg)_brightness(93%)_contrast(89%)]"
                              />
                            </div>

                            <div>
                              <p className="font-normal text-sm max-w-[120px] md:max-w-[320px] truncate">
                                {service.courtDocumentName}
                              </p>
                            </div>
                          </div>

                          <button
                            type="button"
                            onClick={() =>
                              setSelectedDoc({
                                fileName: service?.courtDocumentName,
                                fileUrl: service?.courtDocumentUrl,
                              })
                            }
                            className="min-w-[40px] h-[40px] rounded-[4px] border-[1px] border-solid border-[#B68A35] bg-[#fff] flex items-center justify-center gap-[8px] md:gap-0"
                          >
                            <img
                              src="/assets/img/add-request/Show.svg"
                              width={17}
                              height={17}
                              alt="view"
                              aria-hidden="true"
                              className="transition-all duration-300 filter-[invert(39%)_sepia(49%)_saturate(857%)_hue-rotate(16deg)_brightness(93%)_contrast(89%)]"
                            />
                          </button>
                        </div>
                      )}

                      {service?.subjectDocuments?.map((doc, id) => {
                        return (
                          <div
                            key={id}
                            className="group mt-2 rounded-2xl border !border-[#EEE2D0] bg-white hover:bg-[#FAF7EF] p-4 flex justify-between items-center"
                          >
                            <div className="flex items-center gap-3">
                              <div className="w-11 h-11 rounded-xl bg-[#FBF7EE] flex items-center justify-center">
                                <img
                                  src="/assets/img/documentrequest.svg"
                                  width={24}
                                  height={24}
                                  alt="file"
                                  aria-hidden="true"
                                  className="transition-all duration-300 filter-[invert(39%)_sepia(49%)_saturate(857%)_hue-rotate(16deg)_brightness(93%)_contrast(89%)]"
                                />
                              </div>

                              <div>
                                <p className="font-normal text-sm max-w-[120px] md:max-w-[320px] truncate">
                                  {doc.fileName}
                                </p>
                              </div>
                            </div>

                            <button
                              type="button"
                              onClick={() => setSelectedDoc(doc)}
                              className="min-w-[40px] h-[40px] rounded-[4px] border-[1px] border-solid border-[#B68A35] bg-[#fff] flex items-center justify-center gap-[8px] md:gap-0"
                            >
                              <img
                                src={"/assets/img/add-request/Show.svg"}
                                width={17}
                                height={17}
                                alt="view"
                                aria-hidden="true"
                                className="transition-all duration-300 filter-[invert(39%)_sepia(49%)_saturate(857%)_hue-rotate(16deg)_brightness(93%)_contrast(89%)]"
                              />
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  )}
              </div>
            )}
          </div>

          {(service?.serviceStatusId === 2 ||
            service?.serviceStatusId === 5 ||
            service?.serviceStatusId === 6 ||
            service?.serviceStatusId === 7) &&
          comments.length > 0 ? (
            <div>
              <SmallTitle
                title={
                  lang === "en"
                    ? enPhrase["lblFilesTracking"]
                    : arPhrase["lblFilesTracking"]
                }
              />
              <div className="flex flex-col overflow-hidden border-2 border-solid border-[#EEE2D0] rounded shadow-[0px_10px_40px_#361E1214]">
                {comments
                  ?.slice(0)
                  .reverse()
                  ?.map((comment, indx) => (
                    <div key={indx}>
                      <div className="flex gap-2 text-[12px] text-[#010202] font-medium bg-[#EEE2D0] h-[30px] leading-[30px] px-4">
                        <span className="text-[12px] font-Almarai font-bold">
                          {comment?.name}
                        </span>
                        <span>•</span>
                        <span className="text-[12px] font-Almarai font-bold">
                          {new Date(comment?.createdAt).toLocaleDateString(
                            "en-GB"
                          )}
                        </span>
                      </div>
                      <div className="px-4">
                        <div className="flex flex-row justify-between gap-20 py-4">
                          <p className="text-sm text-[#010202] font-medium max-w-full overflow-clip overflow-x-clip">
                            {comment?.commentText}
                          </p>
                          {indx === 0 &&
                          comment?.name &&
                          service?.serviceStatusId === 2 ? (
                            <button
                              type="button"
                              className="inline-flex justify-center gap-2 items-center h-[44px] rounded-md border border-transparent bg-gold-100 py-4 px-8 text-sm font-bold text-white shadow-sm"
                              onClick={handelOpenPopup}
                            >
                              <span>{lang === "en" ? "Reply" : "رد"}</span>
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="flex gap-4 mb-4">
                          {comment?.documents?.map((el, index) => (
                            <React.Fragment key={index}>
                              {el?.documentUrl.includes("pdf") === true ? (
                                <div className="w-[179px] h-[130px] rounded overflow-hidden">
                                  <PdfViewer fileUrl={el?.documentUrl} lang={lang} />
                                </div>
                              ) : (
                                <img
                                  className="w-[179px] h-[130px] rounded object-cover"
                                  src={el?.documentUrl}
                                  alt=""
                                />
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ) : null}

          {/* Modal for viewing documents from subjectDocuments */}
          {Boolean(selectedDoc) && (
            <SharedModal
              showImage
              openModal={Boolean(selectedDoc)}
              setOpenModal={() => setSelectedDoc(null)}
            >
              <div className="w-full  rounded-t-[16px]">
                {/* Header bar */}
                <div className="h-[56px] w-full flex items-center justify-between px-[24px] bg-[#eee2d0]">
                  <span className="font-bold text-sm text-[#361E12] truncate max-w-[80%] font-Almarai">
                    {selectedDoc?.fileName || selectedDoc?.courtDocumentName}
                  </span>
                  <img
                    src="/assets/img/close.svg"
                    alt="close"
                    className="cursor-pointer h-5 w-5"
                    onClick={() => setSelectedDoc(null)}
                  />
                </div>

                {/* Document Content View */}
                {selectedDoc?.fileName?.toLowerCase().endsWith(".pdf") ||
                selectedDoc?.fileUrl?.toLowerCase().includes(".pdf") ? (
                  <PdfViewer fileUrl={selectedDoc?.fileUrl} lang={lang} />
                ) : (
                  <div className="flex items-center justify-center  bg-white rounded-b-[16px]">
                    <img
                      className="max-w-full h-[288px] md:h-[500px] object-contain rounded-b-[16px]"
                      alt="document view"
                      src={selectedDoc?.fileUrl}
                    />
                  </div>
                )}
              </div>
            </SharedModal>
          )}

          {openModal && (
            <SharedModal isPaymentConfirm setOpenModal={setOpenModal}>
              <ConfirmPayment
                claimedValue={USDollar.format(service?.serviceValue)}
                setOpenModal={setOpenModal}
                service={service}
                caseid={serviceid}
                serviceid={caseid}
                setOpenModalFail={setOpenModalFail}
                setOpenModalSucc={setOpenModalSucc}
              />
            </SharedModal>
          )}

          {openModalFail && (
            <SharedModal setOpenModal={setOpenModalFail}>
              <FailedPayment setOpenModal={setOpenModalFail} />
            </SharedModal>
          )}

          {openModalSucc && (
            <SharedModal setOpenModal={setOpenModalSucc}>
              <SuccessPayment setOpenModal={setOpenModalSucc} />
            </SharedModal>
          )}

          {openPopub && (
            <SharedModal isNeedData setOpenModal={handelOpenPopup}>
              <PopupForm
                handelOpenPopup={handelOpenPopup}
                getCommentsService={getCommentsService}
                serviceid={serviceid}
                setOpenPopub={setOpenPopub}
              />
            </SharedModal>
          )}

          {receiptStatus && (
            <SharedModal isReceiptForm setOpenModal={uploadReceiptHandler}>
              <ReceiptForm
                uploadReceiptHandler={uploadReceiptHandler}
                setReceiptStatus={setReceiptStatus}
                receiptStatus={receiptStatus}
                service={service}
                successUploadReciept={successUploadReciept}
                setSuccessUploadReciept={setSuccessUploadReciept}
                falidUploadReciept={falidUploadReciept}
                setFalidUploadReciept={setFalidUploadReciept}
              />
            </SharedModal>
          )}
        </div>
      )}
    </ThemeLayout>
  );
};

export default OrderDetails;